module.exports = __webpack_public_path__ + "img/sapar_no.b0cd406e.png";